import axiosInstance from "../../api/axiosInstance";

export const fetchAdsWhitelistAPI = async ({
  scopeType = "",
  query = "",
  page = 1,
  limit = 100,
} = {}) => {
  const params = new URLSearchParams();
  if (scopeType) params.set("scopeType", String(scopeType));
  if (query) params.set("query", String(query));
  params.set("page", String(page));
  params.set("limit", String(limit));

  const response = await axiosInstance.get(`ads/whitelist?${params.toString()}`);
  return response.data;
};

export const createAdsWhitelistAPI = async (payload) => {
  const response = await axiosInstance.post("ads/whitelist", payload);
  return response.data;
};

export const deleteAdsWhitelistAPI = async (id) => {
  const response = await axiosInstance.delete(`ads/whitelist/${id}`);
  return response.data;
};
